import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initTheme } from '@/hooks/useTheme';
import { registerServiceWorker } from '@/lib/pwa';
import { installPreloadErrorListener } from '@/lib/chunk-recovery';

installPreloadErrorListener(); // 배포 후 옛 청크 404를 한 번의 조용한 리로드로 흡수 (lib/chunk-recovery.ts)
initTheme();
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
